// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".install[data-v-283b80cc]{display:grid;grid-template-columns:7fr 1fr;align-items:center}.message p[data-v-283b80cc]{color:#fff;font-weight:600}.icon[data-v-283b80cc]{text-align:center}\n", ""]);
// Exports
module.exports = exports;
